import { KeyState } from '../../../shared/interfaces';
import Vec3 from '../../../shared/vec3';

class ScreenController {

  controllerScreen: HTMLInputElement;
  controllerWidth: number;
  controllerHeight: number;

  enabled: boolean;
  changed: boolean;
  data: KeyState;
  buttons: {
    [name: string]: boolean
  }

  constructor() {
      this.enabled = true;
      this.changed = false;

      this.data = {
        ctrl: false,
        shift: false,
        left: false,
        right: false,
        up: false,
        down: false
      }

      this.buttons = {
        mouseDown: false,
        northwest: false,
        north: false,
        northeast: false,
        west: false,
        east: false,
        southwest: false,
        south: false,
        southeast: false
      };
  }

  init() {
    this.controllerScreen = document.getElementById('controllerScreen') as HTMLInputElement
    this.controllerWidth = 160;
    this.controllerHeight = 160;


    this.controllerScreen.addEventListener('mousedown', (e: InputEvent) => {this.buttons.mouseDown = true})
    this.controllerScreen.addEventListener('mouseup', (e: InputEvent) => {this.buttons.mouseDown = false})

    this.controllerScreen.addEventListener('touchstart', (event: TouchEvent) => {this.handleTouch(event)});
    this.controllerScreen.addEventListener('touchmove', (event: TouchEvent) => {this.handleTouch(event)});
    this.controllerScreen.addEventListener('touchend', (event: TouchEvent) => {this.untouch()});


    this.createListeners('northwest');
    this.createListeners('north');
    this.createListeners('northeast');
    this.createListeners('west');
    this.createListeners('east');
    this.createListeners('southwest');
    this.createListeners('south');
    this.createListeners('southeast');
  }

  createListeners(id: string) {
    const element: HTMLInputElement = document.getElementById(`controller-${id}`) as HTMLInputElement
    element.addEventListener('mousedown', (e: InputEvent) => {this.buttons[id] = true; this.updateKeyState()})
    element.addEventListener('mouseenter', (e: InputEvent) => {if(this.buttons.mouseDown) {this.buttons[id] = true; this.updateKeyState()}})
    element.addEventListener('mouseout', (e: InputEvent) => {this.buttons[id] = false; this.updateKeyState()})
    element.addEventListener('mouseup', (e: InputEvent) => {this.buttons[id] = false; this.buttons.mouseDown = false; this.updateKeyState()})
  }

  handleTouch(event: TouchEvent) {
    const controllerCenter = new Vec3(this.controllerWidth / 2, this.controllerHeight / 2, 0);
    const controllerPosition = new Vec3(this.controllerScreen.offsetLeft, this.controllerScreen.offsetTop, 0).add(controllerCenter);

    if(event.targetTouches.length > 0) {
      const touchPosition = new Vec3(event.targetTouches[0].clientX, event.targetTouches[0].clientY, 0);
      const circleRadius = 80;
      const touchVector = touchPosition.sub(controllerPosition)
      const touchVectorLength = touchVector.norm();
      const touchDir = touchVector.normalize();

      if(this.enabled && touchVectorLength <= circleRadius) {
        this.data.up = touchDir.y < -0.33;
        this.data.down = touchDir.y > 0.33;
        this.data.left = touchDir.x < -0.33;
        this.data.right = touchDir.x > 0.33;
        this.changed = true;
      } else {
        this.untouch();
      }
    } else {
      this.untouch();
    }
  }

  untouch() {
    this.data.up = false;
    this.data.down = false;
    this.data.left = false;
    this.data.right = false;
    this.changed = true;
  }

  updateKeyState() {
    if(this.enabled) {
      const {northwest, north, northeast, west, east, southwest, south, southeast} = this.buttons;
      this.data.up = northwest || north || northeast;
      this.data.left = northwest || west || southwest;
      this.data.right = northeast || east || southeast;
      this.data.down = southwest || south || southeast;
      this.changed = true;
    }
  }

  hasChanged() {
    return this.changed;
  }

  setEnabled(value:boolean) {
    this.enabled = value;
  }

  getFullState() {
      this.changed = false;
      return this.data;
  }
}

export default new ScreenController();
